module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./AuthBasicConfigView.jsx"));
	}, "AuthBasicConfig");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AuthBasicConfig!./src/pages/AuthMgr/AuthBasicConfig/AuthBasicConfigView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&name=AuthBasicConfig!./src/pages/AuthMgr/AuthBasicConfig/AuthBasicConfigView.jsx
// module chunks = 43